<template>
  <modal-form v-model="show" :submit="submit" size="lg">
    <template v-slot:title>
      {{ model.Codigo ? 'Editar' : 'Incluir' }} Garantidor / Representante Legal
    </template>
    <template v-slot:body>
      <v-row>
        <v-col cols="3">
          <input-documento label="CPF/CNPJ" required v-model="model.DocumentoFederal" :rules="() => $api.Proposta.ValidaDocumentoEmitente(proposta.Cliente.DocumentoFederal, model.DocumentoFederal)" />
        </v-col>
        <v-col cols="9">
          <input-text label="Nome/Razão Social" required v-model="model.Nome" />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="pa-0">
          <DadosEndereco v-model="model" />
        </v-col>
      </v-row>

      <template v-if="$api.Helper.RetornoTipoPessoa(model.DocumentoFederal) === $aux.TipoPessoaEnum.PF">
        <v-row>
          <v-col cols="12">
            <span class="text-subtitle-2">Dados Pessoais</span>
            <v-divider />
          </v-col>
          <v-col>
            <input-text label="RG/RNE/CNH/OAB" v-model="model.PropostaAvalistaPF.RG" />
          </v-col>
          <v-col >
            <input-datetext  label="Data Nascimento" required v-model="model.PropostaAvalistaPF.DtNasc" />
          </v-col>
          <v-col>
            <input-select :options="$aux.EstadoCivil" @change="$api.Multiplo.ClearConjuge(model.PropostaAvalistaPF)"
              required label="Estado Civil" v-model="model.PropostaAvalistaPF.EstadoCivil" />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pa-0">
            <DadosContato v-model="model.PropostaAvalistaPF" :tipoContato="$aux.TipoDadoEnum.Participante" />
          </v-col>
        </v-row>

        <template v-if="model.PropostaAvalistaPF.EstadoCivil === $aux.EstadoCivilEnum.Casado">
          <v-row>
            <v-col cols="12">
              <span class="text-subtitle-2">Dados do Cônjuge</span>
              <v-divider />
            </v-col>
            <v-col>
              <input-documento required cpf label="CPF" v-model="model.PropostaAvalistaPF.CPFConjuge"
                :rules="() => $api.Proposta.ValidaDocumentoConjuge(model.DocumentoFederal, model.PropostaAvalistaPF.CPFConjuge)" />
            </v-col>
            <v-col>
              <input-text required label="Nome" v-model="model.PropostaAvalistaPF.NomeConjuge" />
            </v-col>
            <v-col>
              <input-text label="RG/RNE/CNH/OAB" v-model="model.PropostaAvalistaPF.RGConjuge" />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-0">
              <DadosContato
                title="Dados de Contato do Cônjuge"
                v-model="model.PropostaAvalistaPF"
                :telefoneFixo="false"
                :tipoContato="$aux.TipoDadoEnum.Conjuge"
                :isRequired="model.PropostaAvalistaPF.EstadoCivil === $aux.EstadoCivilEnum.Casado"
              />
            </v-col>
          </v-row>
        </template>
      </template>

      <template v-else-if="$api.Helper.RetornoTipoPessoa(model.DocumentoFederal) === $aux.TipoPessoaEnum.PJ">
        <v-row>
          <v-col class="pa-0">
            <DadosContato
              v-model="model.PropostaAvalistaPJ"
              :telefoneCelular="false"
              :tipoContato="$aux.TipoDadoEnum.Participante"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span class="text-subtitle-2">Controle Acionário/Societário</span>
            <v-divider />
          </v-col>
          <v-col cols="3">
            <input-documento required label="CPF" cpf v-model="model.PropostaAvalistaPJ.Socio1Documento" />
          </v-col>
          <v-col cols="4">
            <input-text label="Nome" required v-model="model.PropostaAvalistaPJ.Socio1Nome"></input-text>
          </v-col>
          <v-col cols="3">
            <input-datetext
              label="Data Entrada Sócio"
              :rules="() => $api.Proposta.ValidaDataFundacao(model, 1)"
              v-model="model.PropostaAvalistaPJ.Socio1DtEntrada">
            </input-datetext>
          </v-col>
          <v-col cols="2">
            <input-text required label="RG/RNE/CNH/OAB"
              v-model="model.PropostaAvalistaPJ.Socio1RG"></input-text>
          </v-col>
          <v-col cols="3">
            <input-documento label="CPF" cpf v-model="model.PropostaAvalistaPJ.Socio2Documento"></input-documento>
          </v-col>
          <v-col cols="4">
            <input-text label="Nome" v-model="model.PropostaAvalistaPJ.Socio2Nome"></input-text>
          </v-col>
          <v-col cols="3">
            <input-datetext
              label="Data Entrada Sócio"
              :rules="() => $api.Proposta.ValidaDataFundacao(model, 2)"
              v-model="model.PropostaAvalistaPJ.Socio2DtEntrada">
            </input-datetext>
          </v-col>
          <v-col cols="2">
            <input-text label="RG/RNE/CNH/OAB" v-model="model.PropostaAvalistaPJ.Socio2RG"></input-text>
          </v-col>
          <v-col cols="3">
            <input-documento label="CPF" cpf v-model="model.PropostaAvalistaPJ.Socio3Documento"></input-documento>
          </v-col>
          <v-col cols="4">
            <input-text label="Nome" v-model="model.PropostaAvalistaPJ.Socio3Nome"></input-text>
          </v-col>
          <v-col cols="3">
            <input-datetext
              label="Data Entrada Sócio"
             :rules="() => $api.Proposta.ValidaDataFundacao(model, 3)"
              v-model="model.PropostaAvalistaPJ.Socio3DtEntrada">
            </input-datetext>
          </v-col>
          <v-col cols="2">
            <input-text label="RG/RNE/CNH/OAB" v-model="model.PropostaAvalistaPJ.Socio3RG"></input-text>
          </v-col>

          <v-col cols="3">
            <input-documento label="CPF" cpf v-model="model.PropostaAvalistaPJ.Socio4Documento"></input-documento>
          </v-col>
          <v-col cols="4">
            <input-text label="Nome" v-model="model.PropostaAvalistaPJ.Socio4Nome"></input-text>
          </v-col>
          <v-col cols="3">
            <input-datetext
              label="Data Entrada Sócio"
              :rules="() => $api.Proposta.ValidaDataFundacao(model, 4)"
              v-model="model.PropostaAvalistaPJ.Socio4DtEntrada">
            </input-datetext>
          </v-col>
          <v-col cols="2">
            <input-text label="RG/RNE/CNH/OAB" v-model="model.PropostaAvalistaPJ.Socio4RG"></input-text>
          </v-col>
          <v-col cols="3">
            <input-documento label="CPF" cpf v-model="model.PropostaAvalistaPJ.Socio5Documento"></input-documento>
          </v-col>
          <v-col cols="4">
            <input-text label="Nome" v-model="model.PropostaAvalistaPJ.Socio5Nome"></input-text>
          </v-col>
          <v-col cols="3">
            <input-datetext
              label="Data Entrada Sócio"
              :rules="() => $api.Proposta.ValidaDataFundacao(model, 5)"
              v-model="model.PropostaAvalistaPJ.Socio5DtEntrada">
            </input-datetext>
          </v-col>
          <v-col cols="2">
            <input-text label="RG/RNE/CNH/OAB" v-model="model.PropostaAvalistaPJ.Socio5RG"></input-text>
          </v-col>
        </v-row>
      </template>
    </template>
  </modal-form>

</template>
<script>
export default {
  props: {
    proposta: null
  },
  data () {
    return {
      show: false,
      model: {
        PropostaAvalistaPF: {},
        PropostaAvalistaPJ: {},
      },
      mensagemErroData: 'Data de entrada não pode ser anterior a data de fundação',
      permiteSeguirParaSocio: false
    }
  },
  computed: {
    tipo () {
      const th = this;
      if (th.model.DocumentoFederal) {
        const tipoPessoa = th.$api.Helper.RetornoTipoPessoa(th.model.DocumentoFederal);
        return tipoPessoa === th.$aux.TipoPessoaEnum.PF ? 'PF' : (tipoPessoa === th.$aux.TipoPessoaEnum.PJ ? 'PJ' : false);
      }
      return true;
    }
  },
  methods: {
    openModal (sender, nome, documento) {
      const th = this
      th.model = {
        PropostaAvalistaPF: {},
        PropostaAvalistaPJ: {}
      }
      th.show = true
      th.model.CodigoProposta = th.proposta.Codigo
      if (nome && documento) {
        th.model.Nome = nome
        th.model.DocumentoFederal = documento
      }
      if (sender) {
        th.$api.Multiplo.FindRecordPropostaAvalista({ guidID: sender.Codigo }).then(function (response) {
          if (th.$api.UI.PostLoadData(response, true)) {
            if (response.PropostaAvalistaPF) {
              if (response.PropostaAvalistaPF.TelefoneCelular) {
                response.PropostaAvalistaPF.TelefoneCelular =
                  th.$api.UI.Format.Celular(
                    response.PropostaAvalistaPF.TelefoneCelular
                  );
              }

              if (response.PropostaAvalistaPF.TelefoneFixo) {
                response.PropostaAvalistaPF.TelefoneFixo =
                  th.$api.UI.Format.Telefone(
                    response.PropostaAvalistaPF.TelefoneFixo
                  );
              }
            }

            if (response.PropostaAvalistaPJ) {
              if (response.PropostaAvalistaPJ.TelefoneFixoTrabalho) {
                response.PropostaAvalistaPJ.TelefoneFixoTrabalho =
                  th.$api.UI.Format.Telefone(
                    response.PropostaAvalistaPF.TelefoneFixoTrabalho
                  );
              }

              if (response.PropostaAvalistaPJ.TelefoneCelularTrabalho) {
                response.PropostaAvalistaPJ.TelefoneCelularTrabalho =
                  th.$api.UI.Format.Celular(
                    response.PropostaAvalistaPF.TelefoneCelularTrabalho
                  );
              }
            }

            th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', response)
          }
        })
      }
    },
    submit () {
      const th = this
      if (th.$api.Helper.RetornoTipoPessoa(th.model.DocumentoFederal) === th.$aux.TipoPessoaEnum.PJ && th.model.PropostaAvalistaPJ) {
        for (var i = 1; i < 6; i++) {
          if (th.model.PropostaAvalistaPJ[`Socio${i}Documento`]) { th.model.PropostaAvalistaPJ[`Socio${i}Percentual`] = 100 }
        }
      }
      if (th.$api.Helper.RetornoTipoPessoa(th.model.DocumentoFederal) === th.$aux.TipoPessoaEnum.PF && th.model.PropostaAvalistaPF) {
        th.$set(th.model.PropostaAvalistaPF, 'MostrarConjugeCCB', th.model.PropostaAvalistaPF.EstadoCivil === th.$aux.EstadoCivilEnum.Casado)
        const dtoGarantia = { parameters: [{ name: 'CodigoProposta', value: th.proposta.Codigo }] }
        th.$api.Multiplo.ListPropostaGarantiaBem(dtoGarantia).then(async function (response) {
          if (th.$api.UI.PostLoadData(response)) {
            const isProprietario = response.Data.find(p => th.$api.UI.Format.SomenteNumeros(p.DocumentoFederalProprietario) === th.$api.UI.Format.SomenteNumeros(th.model.DocumentoFederal))
            if (isProprietario && !th.model.Codigo) {
              var dto = [{
                CodigoProposta: th.proposta.Codigo,
                Nome: th.model.Nome,
                Email: th.model.PropostaAvalistaPF.Email,
                Documento: th.model.DocumentoFederal,
                TelefoneCelular: th.model.PropostaAvalistaPF.TelefoneCelular,
                Descricao: 'TERCEIRO GARANTIDOR',
              }]
              th.$api.Multiplo.InsertCCBDigitalAssinaturas({ dto: dto }).then(function (response) {
                if (th.$api.UI.PostLoadData(response, true)) { }
              })
            }
          }
        })
      }
      th.$api.Multiplo.SavePropostaAvalista({ dto: th.model }).then(function (response) {
        if (th.$api.UI.PostAction(response)) {
          th.show = false
          th.$emit('close', !response.error)
        }
      })
    },
  },
  watch: {
    'model.PropostaAvalistaPF.EstadoCivil' (val) {
      if (val !== this.$aux.EstadoCivilEnum.Casado) {
        this.$set(this.model, 'PropostaAvalistaPF', {
          ...this.model.PropostaAvalistaPF,
          CPFConjuge: '',
          NomeConjuge: '',
          RGConjuge: '',
          TelefoneCelularConjuge: '',
          EmailConjuge: ''
        })
      }
    }
  }
}
</script>
